export default "__VITE_ASSET__BuPpEEOZ__"